<ppl-top-bar>
  <ppl-top-navigation></ppl-top-navigation>
</ppl-top-bar>

<ppl-app-container>
  <div class="align-in-center">
    <ppl-box-container-with-header title="User profile settings"
                                   i18n-title="@@User_profile_settings"
                                   [titleUnderlined]="false">
      <ppl-items-nav [value]="tabItem$ | async"
                     [items]="tabItems"
                     [disabled]="loading$ | async"
                     (itemClick)="onTabItemClick($event)">
        <ng-container [ngSwitch]="tabItem$ | async">

          <ng-container *ngSwitchCase="TabItem.Personal">
            <ppl-form-container [formGroup]="form">
              <ppl-form-row>
                <div class="picture-column">
                  <ppl-input-container>
                    <div class="picture-wrapper">
                      <ppl-addressbook-picture width="140px"
                                               height="140px"
                                               [isEditable]="true"
                                               [forceRound]="true"
                                               [picture]="pictureUrl"
                                               (pictureChange)="onPictureChange($event)"></ppl-addressbook-picture>
                    </div>
                  </ppl-input-container>
                </div>
                <ppl-form-column>
                  <ppl-input-container label="Email"
                                       i18n-label="@@Email"
                                       [pplFormControl]="form.get('email')">
                    <input pplInput
                           name="email"
                           type="email"
                           autocomplete="username"
                           formControlName="email" />
                  </ppl-input-container>
                  <ppl-input-container label="Phone"
                                       i18n-label="@@Phone"
                                       [pplFormControl]="form.get('telephone')">
                    <input pplInput
                           formControlName="telephone" />
                  </ppl-input-container>
                </ppl-form-column>
              </ppl-form-row>

              <ppl-form-row>
                <ppl-form-column>
                  <ppl-input-container label="First name"
                                       i18n-label="@@First_name"
                                       [pplFormControl]="form.get('firstName')">
                    <input pplInput
                           formControlName="firstName" />
                  </ppl-input-container>
                </ppl-form-column>
                <ppl-form-column>
                  <ppl-input-container label="Middle name"
                                       i18n-label="@@Middle_name"
                                       [pplFormControl]="form.get('middleName')">
                    <input pplInput
                           formControlName="middleName" />
                  </ppl-input-container>
                </ppl-form-column>
                <ppl-form-column>
                  <ppl-input-container label="Last name"
                                       i18n-label="@@Last_name"
                                       [pplFormControl]="form.get('lastName')">
                    <input pplInput
                           formControlName="lastName" />
                  </ppl-input-container>
                </ppl-form-column>
              </ppl-form-row>

              <ppl-form-row>
                <ppl-form-column>
                  <ppl-input-container label="Company"
                                       i18n-label="@@Company"
                                       [pplFormControl]="form.get('company')">
                    <input pplInput
                           formControlName="company" />
                  </ppl-input-container>
                </ppl-form-column>
              </ppl-form-row>

              <ppl-form-row>
                <ppl-form-column>
                  <ppl-input-container label="Language"
                                       i18n-label="@@Language"
                                       [pplFormControl]="form.get('language')">
                    <ppl-select formControlName="language"
                                [options]="languages"></ppl-select>
                  </ppl-input-container>
                </ppl-form-column>
              </ppl-form-row>

              <ppl-form-row>
                <ppl-form-column>
                  <ppl-input-container label="Timezone"
                                       i18n-label="@@Timezone"
                                       pplFormControlName="timezone">
                    <ppl-select formControlName="timezone"
                                [options]="timezones"></ppl-select>
                  </ppl-input-container>
                </ppl-form-column>
              </ppl-form-row>

              <ppl-form-row>
                <ppl-form-column>
                  <ppl-input-container label="Region"
                                       i18n-label="@@Region"
                                       [pplFormControl]="form.get('locale')">
                    <ppl-select formControlName="locale"
                                [options]="regions"></ppl-select>
                  </ppl-input-container>
                </ppl-form-column>
              </ppl-form-row>

              <div class="info-box-container">
                <ng-container *ngIf="!(localesLoading$ | async);">
                  <div class="info-box">
                    <div class="info-box-item">
                      <div class="info-title">
                        <ng-container i18n="@@Date">Date</ng-container> / <ng-container i18n="@@Time">Time</ng-container>
                      </div>
                      <div class="info-value">{{ currentDateTime | pplDateTime }}</div>
                    </div>
                    <div class="info-box-item">
                      <div class="info-title"
                           i18n="@@Number">Number</div>
                      <div class="info-value">{{ 1200013200 | pplDecimal }}</div>
                    </div>
                    <div class="info-box-item">
                      <div class="info-title"
                           i18n="@@Decimal">Decimal</div>
                      <div class="info-value">{{ 1200013200.12 | pplDecimal }}</div>
                    </div>
                    <div class="info-box-item">
                      <div class="info-title"
                           i18n="@@Currency">Currency</div>
                      <div class="info-value"> {{ 1200013279 | pplCurrency:'USD' }}</div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ppl-form-container>
          </ng-container>

          <div *ngSwitchCase="TabItem.Security"
               class="security">
            <ppl-content-block label="Password"
                               i18n-label="@@Password">
              <ppl-box-section title="********"
                               class="box-change-password">
                <button class="content-section"
                        pplButton
                        pplButton1
                        pplButtonSmall
                        (click)="onChangePassword()"
                        i18n="@@Change_Password">Change Password</button>
                <div class="content-section info-text">
                  <ng-container i18n="@@Password_was_last_changed:">Password was last changed:</ng-container>&nbsp;
                  <ppl-async-view [state]="lastPasswordChangeLoadState$ | async">
                    <ng-template #asyncViewFetched>{{ (lastPasswordChange$ | async).value | pplDateTime }}</ng-template>
                  </ppl-async-view>
                </div>
              </ppl-box-section>
            </ppl-content-block>

            <ppl-content-block label="Mobile Sign In"
                               i18n-label="@@Mobile_Sign_In"
                               [actionTemplate]="mobileSignInAction">
              <!--<div class="mobile-sign-in-state info-text">
              <ng-container i18n="@@Enabled_since">Enabled since</ng-container> ...
            </div>-->

              <ppl-info-box *ngIf="!mobileSignInEnabled"
                            class="mobile-sign-in-state"
                            type="warning"
                            text="Signing in on mobile devices using a QR Code has been disabled. Contact your administrator."
                            i18n-text="@@Signing_in_on_mobile_devices_using_a_QR_Code_has_been_disabled._Contact_your_administrator."></ppl-info-box>

              <ppl-mobile-sign-in-session-list #mobileSignInSessionList
                                               [securityToken]="securityToken"></ppl-mobile-sign-in-session-list>
            </ppl-content-block>
            <ng-template #mobileSignInAction>
              <button *ngIf="mobileSignInEnabled"
                      pplButton
                      pplButton1
                      pplButtonSmall
                      type="button"
                      i18n="@@Show_QR_Code"
                      (click)="onShowQrCodeClick()">Show QR Code</button>
            </ng-template>

            <ppl-content-block label="Pipeliner Identification Provider"
                               i18n-label="@@Pipeliner_Identification_Provider"
                               [formGroup]="defaultIDPForm">
              <ppl-box-section title="Primary Identification Provider"
                               i18n-title="@@Primary_Identification_Provider">
                <ppl-input-container pplFormControlName="defaultIdp"
                                     class="idp-input-container">
                  <ppl-select class="content-section"
                              [value]="defaultIDPForm.get('defaultIdp').value"
                              [options]="availableIDPs"
                              (valueChange)="onDefaultIDPChange($event)"></ppl-select>
                </ppl-input-container>
                <div class="content-section info-text"
                     i18n="@@UserProfileIDPInfoText">Identification provider is a service that stores and verifies user identity. Default IDP is Pipeliner</div>
              </ppl-box-section>
            </ppl-content-block>

            <ng-template #toggleTwoStepVerificationTemplate>
              <ppl-slide-toggle [value]="twoFactorEnabled$ | async"
                                [toggleImmediately]="false"
                                [disabled]="!securityToken"
                                (valueChange)="onToggle2StepVerification(!$event)"></ppl-slide-toggle>
            </ng-template>
            <ppl-content-block label="2-Step Verification"
                               i18n-label="@@2-Step_Verification"
                               class="two-step-verification"
                               [actionTemplate]="toggleTwoStepVerificationTemplate">
              <div *ngIf="twoFactorEnabledSince$ | async as enabledSince"
                   class="section info-text"
                   i18n="@@UserProfileTwoFactorEnabledSince">Enabled since {{ enabledSince | pplDateTime }}</div>
              <ppl-two-factor-method class="section"
                                     title="Email Message"
                                     i18n-title="@@Email_Message"
                                     [titleIcon]="methodTypeToIconMap[TwoFAType.EMAIL]"
                                     description="Verification codes will be sent to the selected email address."
                                     i18n-description="@@TwoFactorMethodEmailMessageDescription"
                                     subTitle="Email Address"
                                     i18n-subTitle="@@Email_Address"
                                     [entries]="twoFactorEmails$ | async"
                                     [addButtonDisabled]="(twoFactorEmails$ | async).length >= MAX_TWO_FACTOR_METHOD_COUNT"
                                     (add)="onTwoFactorAdd(TwoFAType.EMAIL)"
                                     (delete)="onTwoFactorDelete($event)"></ppl-two-factor-method>

              <ppl-two-factor-method class="section"
                                     title="Text Message (SMS)"
                                     i18n-title="@@Text_Message_(SMS)"
                                     [titleIcon]="methodTypeToIconMap[TwoFAType.SMS]"
                                     description="Verification codes will be sent by text messages on the selected phone number(s)."
                                     i18n-description="@@TwoFactorMethodTextMessageDescription"
                                     subTitle="Phone Number(s)"
                                     i18n-subTitle="@@Phone_Number(s)"
                                     [entries]="twoFactorSMS$ | async"
                                     [addButtonDisabled]="(twoFactorSMS$ | async).length >= MAX_TWO_FACTOR_METHOD_COUNT"
                                     (add)="onTwoFactorAdd(TwoFAType.SMS)"
                                     (delete)="onTwoFactorDelete($event)"></ppl-two-factor-method>

              <ppl-two-factor-method class="section"
                                     title="Authenticator App"
                                     i18n-title="@@Authenticator_App"
                                     [titleIcon]="methodTypeToIconMap[TwoFAType.AUTH_APP]"
                                     description="Generate one-time verification codes on your phone via an app."
                                     i18n-description="@@TwoFactorMethodAuthenticatorAppDescription"
                                     subTitle="Authenticator App"
                                     i18n-subTitle="@@Authenticator_App"
                                     [entries]="twoFactorAuthApps$ | async"
                                     [addButtonDisabled]="(twoFactorAuthApps$ | async).length >= MAX_TWO_FACTOR_METHOD_COUNT"
                                     (add)="onTwoFactorAdd(TwoFAType.AUTH_APP)"
                                     (delete)="onTwoFactorDelete($event)">
                <div ngProjectAs="extra-description"
                     class="auth-app-extra-description">
                  <div class="info-text"
                       i18n="@@To_get_started:">To get started:</div>
                  <ng-container *ngTemplateOutlet="downloadAndInstall; context: {
                    $implicit: 'Microsoft Authenticator',
                    appleUrl: 'https://apps.apple.com/us/app/microsoft-authenticator/id983156458',
                    androidUrl: 'https://play.google.com/store/apps/details?id=com.azure.authenticator'
                  }"></ng-container>
                  <ng-container *ngTemplateOutlet="downloadAndInstall; context: {
                    $implicit: 'Google Authenticator',
                    appleUrl: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
                    androidUrl: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
                  }"></ng-container>
                </div>
              </ppl-two-factor-method>

              <ppl-two-factor-backup-codes class="section"
                                           [method]="twoFactorBackupCodes$ | async"
                                           [securityToken]="securityToken$ | async"
                                           [disabled]="!(twoFactorEnabled$ | async)"
                                           (toggle)="onToggleBackupCodes($event)"></ppl-two-factor-backup-codes>
            </ppl-content-block>
          </div>
        </ng-container>

        <div class="buttons">
          <button *ngIf="(tabItem$ | async) !== TabItem.Security"
                  pplButton
                  pplButtonSave
                  i18n="@@Save"
                  [disabled]="saving$ | async"
                  (click)="onSave()">Save</button>
          <button pplButton
                  pplButtonCancel
                  i18n="@@Cancel"
                  (click)="onCancel()">Cancel</button>
        </div>
      </ppl-items-nav>

      <ppl-loading-overlay *ngIf="(loading$ | async) || (saving$ | async)"
                           [large]="true"
                           [visible]="true"
                           [inverse]="true"></ppl-loading-overlay>
    </ppl-box-container-with-header>
  </div>
</ppl-app-container>

<ng-template #downloadAndInstall
             let-name
             let-androidUrl="androidUrl"
             let-appleUrl="appleUrl">
  <div class="auth-app-download-links-container">
    <span i18n="@@TwoFactorMethodAuthenticatorAppDownloadLink">Download and install the <strong>{{ name }}</strong> application on your mobile device.</span>
    <div class="auth-app-download-links"
         [attr.title]="name">
      <a target="_blank"
         [href]="appleUrl">
        <ppl-icon svgIcon="apple-logo-light-gray"
                  height="18px"
                  width="18px"></ppl-icon>

      </a>
      <a target="_blank"
         [href]="androidUrl">
        <ppl-icon svgIcon="android-logo-light-gray"
                  height="18px"
                  width="18px"></ppl-icon>
      </a>
    </div>
  </div>
</ng-template>
